import * as Yup from 'yup';
import { AdminBillingListBase } from '~services/admin/billingList/types';

import { VALIDATIONS_ERROR } from '~constants/index';

export const FIELDS_NAME = {
  BILLING_LIST_ID: 'billingListId',
} as const;

export const initialValues = {
  [FIELDS_NAME.BILLING_LIST_ID]: '',
};

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.BILLING_LIST_ID]: Yup.string().required(
    VALIDATIONS_ERROR.REQUIRED,
  ),
});

export const DEFAULT_BILLING_LIST_OPTION: AdminBillingListBase = {
  billingListCode: '',
  billingListId: '_unassigned',
  companyId: '',
  creationDateTime: '',
  description: 'Sin asignar',
  enabled: true,
  lastUpdateDateTime: null,
  maxDeliveryBusinessDays: 0,
  userId: '',
  valuationTypeId: 0,
};
